import React from 'react';

type FlagIconProps = {
  onClick?: React.MouseEventHandler<SVGSVGElement>;
  className?: string;
};

export function FlagIcon({ onClick, className = '' }: FlagIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      className={className}
      onClick={onClick}
    >
      <path
        d="M3.33333 13.3333L3.33333 2.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.33333 10.8333C3.33333 10.8333 4.16667 10 6.66667 10C9.16667 10 10.8333 11.6667 13.3333 11.6667C15.8333 11.6667 16.6667 10.8333 16.6667 10.8333V2.5C16.6667 2.5 15.8333 3.33333 13.3333 3.33333C10.8333 3.33333 9.16667 1.66667 6.66667 1.66667C4.16667 1.66667 3.33333 2.5 3.33333 2.5"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default FlagIcon;
